import { FC, Fragment, useCallback } from 'react';
// i18next
import { useTranslation } from 'react-i18next';
// Types
import Interactions from 'types/Interactions';
import QuizTypes from 'types/QuizTypes';
// Redux
import { useAppDispatch, useAppSelector } from 'hooks/useStore';
// Async
import { createAnalyticsInteract } from 'store/player/playerAsync';
// Selectors
import { selectQuiz } from 'store/quiz/quizSelectors';
import { selectResultId } from 'store/auth/authSelectors';
// Components
import { Button } from 'components/Buttons';

const PostQuizData:FC = () => {
  const { t } = useTranslation();

  const dispatch = useAppDispatch();

  const quiz:any = useAppSelector(selectQuiz);
  const resultId = useAppSelector(selectResultId);

  const handleProceedClick = useCallback((interaction:Interactions) => {
    if (!resultId) return;
    dispatch(createAnalyticsInteract({
      result: resultId,
      name: interaction
    }));
    // eslint-disable-next-line
  }, [resultId]);

  const showBonusPointsHint = ![QuizTypes.Poll, QuizTypes.RankingPoll, QuizTypes.TeamSelector, QuizTypes.Survey].includes(quiz.type) && quiz.callToAction.clickBonusPoints;

  if ( [QuizTypes.Personality].includes(quiz.type) ) return null;
  if ( !quiz.callToAction.enabled ) return null;
  return (
    <Fragment>
      {quiz.callToAction.title ? (
        <h3 className="text-center text-3xl text-primary font-bold px-4 mb-6">
          {quiz.callToAction.title}
        </h3>
      ) : null}
      
      {showBonusPointsHint ? (
        <h3 className="text-center text-xl text-primary font-bold px-4 mb-6">
          {t('pages.postQuiz.title', { points: quiz.callToAction.clickBonusPoints })}
        </h3>
      ) : null}

      {quiz.callToAction.image ? (
        <a
          className="block rounded mb-4 overflow-hidden border border-white flex-shrink-0"
          href={quiz.callToAction.url || undefined}
          target="_blank"
          rel="noreferrer"
          onClick={() => handleProceedClick(Interactions.CtaUrlClick)}
        ><img src={quiz.callToAction.image} style={{ width: '100%', height: 'auto' }} alt={quiz.callToAction.text || `${t('buttons.visit')} ${quiz.namespace}`} /></a>
      ) : null}

      <div className="flex-1" />

      {quiz.callToAction.url ? (
        <a href={quiz.callToAction.url} target="_blank" rel="noreferrer">
          <Button
            className="w-full !text-xl primary-button normal-case"
            size="small"
            onClick={() => handleProceedClick(Interactions.CtaUrlClick)}
          >
            {quiz.callToAction.text || `${t('buttons.visit')} ${quiz.namespace}`}
          </Button>
        </a>
      ) : null}

      {quiz.callToAction.url2 ? (
        <a href={quiz.callToAction.url2} target="_blank" rel="noreferrer">
          <Button
            className="w-full !text-xl primary-button normal-case mt-4"
            size="small"
            onClick={() => handleProceedClick(Interactions.CtaUrl2Click)}
          >
            {quiz.callToAction.text2 || `${t('buttons.visit')} ${quiz.namespace}`}
          </Button>
        </a>
      ) : null}
    </Fragment>
  )
}

export default PostQuizData;
